import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import './AdminProducts.css';
import Loader from '../Loader';
const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [loading, setLoading] = useState(true);  // To handle loading state
  

  // Predefined categories
  const predefinedCategories = ['Books', 'Bags', 'Letterhead', 'Branding', 'Clothes', 'Fliers', 'Business Cards', 'Caps', 'Custom Mugs', 'Calendar',];

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);  // Set loading before fetching
      try {
        const productCollection = collection(db, 'products');
        const productSnapshot = await getDocs(productCollection);
        const productsList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProducts(productsList); // Initialize with all products
        setLoading(false);  // Stop loading after fetching
      } catch (err) {
        console.error('Error fetching products:', err);
        setLoading(false);  // Stop loading on error
      }
    };

    const fetchCategories = async () => {
      try {
        const categoryCollection = collection(db, 'categories');
        const categorySnapshot = await getDocs(categoryCollection);
        const fetchedCategories = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Merge predefined categories with fetched categories, avoiding duplicates
        const allCategories = [...new Set([...predefinedCategories, ...fetchedCategories.map(c => c.name)])];
        setCategories(allCategories.map(name => ({ id: name, name }))); // Normalize to an array of objects
      } catch (err) {
        console.error('Error fetching categories:', err);
      }
    };

    fetchProducts();
    fetchCategories();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCategoryChange = async (e) => {
    const categoryName = e.target.value;
    setSelectedCategory(categoryName);

    setLoading(true);  // Set loading while changing category
    try {
      const productCollection = collection(db, 'products');
      let productSnapshot;

      if (categoryName) {
        const q = query(productCollection, where('categoryName', '==', categoryName));
        productSnapshot = await getDocs(q);
      } else {
        productSnapshot = await getDocs(productCollection);
      }

      const productsList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProducts(productsList);
      setLoading(false);  // Stop loading after fetching
    } catch (err) {
      console.error('Error fetching products:', err);
      setLoading(false);  // Stop loading on error
    }
  };

 

  if (loading) return <div><Loader/></div>;

  return (
    <div className='product-list'>
      <h2>Browse All Printing Catalog</h2>
      <div>
        <select value={selectedCategory} onChange={handleCategoryChange} className='product-select' data-aos="zoom-in">
          <option value=''>All Categories</option>
          {categories.map((category) => (
            <option key={category.id} value={category.name}>{category.name}</option>
          ))}
        </select>
      </div>

      <div className='product-container'>
        {products.map((product) => (
          <div key={product.id} className='product-box box'
        >
            <Link to={`/product/${product.id}`}>
              <img src={product.imageUrl} alt={product.name} />
            </Link>
            <h3 className='fade-in'>{product.name}</h3>
            <p className='pricee'>₦{product.price} <span>/</span> {product.quantity}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductList;
